import { fetchEffectivePermissions, getPermissions } from './services/entitlements/entitlements.service';
import { fetchProfile, getProfile, saveProfile } from './services/profile/profile.service';
import { fetchFilters, getFilters, getFiltersTagsMap } from './services/tags/tagsService';
import api from './api/apiService';
import { auth$ } from './services/auth';
import { trackUrlChanges } from './services/usage';

auth$.subscribe((token) => {
  if (token) {
    fetchEffectivePermissions();
    fetchFilters();
    fetchProfile();
  }
});

trackUrlChanges();

export { api };
export { getFilters };
export { getFiltersTagsMap };
export { getPermissions };
export { getProfile, saveProfile };
export { type Profile } from './models/Profile';
export { PermissionEnum, UserSubscription, UserPermissions, CONTENTTYPE_PERMISSIONS_MAP } from './models/Permissions';
export { ContentType } from './models/ContentType';
export { FilterTypeEnum, type FilterDto, type FilterItemDto, type Tag } from './models/Tags';
export {
  getCurrentUser,
  auth$,
  signIn,
  signOut,
  onTokenChange,
  redirectToSSO,
  signInBySSO,
  signInBySharedLogin,
} from './services/auth';
export { type User } from './models/Auth';
export { fetchSortedSavedSearches } from './services/searches/savedSearches.service';
export { getSortedSavedSearches } from './utils/searches';
export {
  type SavedSearchDto,
  type SavedSearchFilterDto,
  type SavedSearch,
  type SavedSearchFilter,
  type SavedSearchDateRange,
  FILTER_RELATIVE_DATE_RANGE,
  SavedSearchPage,
} from './models/SavedSearch';
export { type PreferenceDto, type UpdatePreferenceDto, type CreatePreferenceDto } from './models/Preference';
export {
  fetchPreferences,
  preferencesUri,
  fetchPreference,
  createPreference,
  updatePreference,
  fetchPreferenceByKey,
  updatePreferenceByKey,
} from './services/preferences/preferences.service';
export { trackUsage } from './services/usage';
export { type Snippet, SnippetType, type SnippetList, type SnippetParams } from './models/Snippet';
export { fetchSnippet, fetchSnippets } from './services/snippets/snippet.service';
